import { supabase } from '../lib/supabase.js';
import { setState } from '../state/store.js';
import { isOnline, OFFLINE_SAVE_MESSAGE } from '../lib/onlineGuard.js';

export async function loadMaterialsForSite(siteId) {
  if (!siteId) {
    setState({ materialRecords: [] });
    return;
  }
  setState({ materialRecordsLoading: true });
  const { data, error } = await supabase
    .from('material_purchases')
    .select('id, purchase_date, material_name, unit, quantity, rate, supplier, bill_file_path, notes, created_at')
    .eq('site_id', siteId)
    .order('purchase_date', { ascending: false })
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Failed to load materials', error);
    setState({ materialRecords: [], materialRecordsLoading: false });
    return;
  }
  setState({ materialRecords: data || [], materialRecordsLoading: false });
}

async function uploadBillIfAny(file, siteId) {
  if (!file) return { ok: true, path: null };
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  const path = `${siteId}/${Date.now()}-${safeName}`;
  const { error } = await supabase.storage.from('bills').upload(path, file);
  if (error) return { ok: false, error: error.message };
  return { ok: true, path };
}

/**
 * fields: { site_id, purchase_date, material_name, unit, quantity, rate, supplier, notes, payment_mode }
 * billFile: optional File
 * Calls the EXISTING create_material_purchase_atomic RPC -- does not insert into
 * material_purchases/transactions directly. Returns { ok, error }.
 */
export async function saveMaterial(fields, billFile) {
  if (!isOnline()) return { ok: false, error: OFFLINE_SAVE_MESSAGE };
  if (!fields.site_id) return { ok: false, error: 'No site selected' };
  if (!fields.material_name || !fields.material_name.trim()) return { ok: false, error: 'Material is required' };
  const quantity = Number(fields.quantity);
  const rate = Number(fields.rate);
  if (!quantity || quantity <= 0) return { ok: false, error: 'Enter a valid quantity (> 0)' };
  if (fields.rate === '' || isNaN(rate) || rate < 0) return { ok: false, error: 'Enter a valid rate (>= 0)' };

  const uploaded = await uploadBillIfAny(billFile, fields.site_id);
  if (!uploaded.ok) return { ok: false, error: 'Bill upload failed: ' + uploaded.error };

  const { error } = await supabase.rpc('create_material_purchase_atomic', {
    p_site_id: fields.site_id,
    p_purchase_date: fields.purchase_date,
    p_material_name: fields.material_name.trim(),
    p_unit: fields.unit,
    p_quantity: quantity,
    p_rate: rate,
    p_supplier: fields.supplier || null,
    p_bill_file_path: uploaded.path,
    p_notes: fields.notes || null,
    p_payment_mode: fields.payment_mode || null
  });

  if (error) return { ok: false, error: error.message };
  return { ok: true };
}
